import ABSplitDisplay from './ABSplitDisplay'
import ABSplitForm from './ABSplitForm.container'
import IconSplit from 'components/Icons/Split'

export default {
  id: 'ab_split',
  label: 'AB Split',
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/ab-split',
  icon: IconSplit,
  inputs: [{}],
  outputs: [
    {
      name: 'A',
      label: 'Option A',
    },
    {
      name: 'B',
      label: 'Option B',
    },
  ],
  display: ABSplitDisplay,
  form: ABSplitForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ABSplit/index.js